export default "__VITE_ASSET__CLcT8Wn7__"